import { render, staticRenderFns } from "./PastSessions.vue?vue&type=template&id=2683bc76&"
import script from "./PastSessions.vue?vue&type=script&lang=ts&"
export * from "./PastSessions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports